import { BrandConfig } from './types';

export const repasse: BrandConfig = {
	id: 'repasse',
	appName: 'Canal do Repasse',
	basePath: '',
	logoFile: 'logo.png',
	registerUrl: 'https://www.canaldorepasse.com.br/cadastro.aspx',
	contacts: {
		email: 'contato@canaldorepasse.com.br',
		phone: '+5531987859735',
		proneFormatted: '(31) 98785-9735',
		address: 'Rua XPTO, 0',
		// Numero usado na home publica (layout aprovado). Confirmar com o comercial.
		whatsappNumber: '553131814955',
		whatsappFormatted: '+55 31 3181-4955',
	},
	colors: {
		primaryLighter: 'rgba(239, 23, 33, .05)',
		primaryLight: '#ff944d',
		primaryMedium: '#f60',
		accent: '#fe6600',
		accentSoft: 'rgba(255, 102, 0, 0.08)',
		neutralBlack: '#111111',
		neutralYellow: '#ffcc00',
		muiPrimaryMain: '#fe6600',
		muiPrimaryLight: '#ff944d',
		muiPrimaryDark: '#f60',
	},
	api: {
		baseApiUrl: {
			dev: 'https://www.canaldorepasse.com.br/webservice/api',
			prod: 'https://www.canaldorepasse.com.br/webservice/api',
		},
		// baseApiUrl: {
		// 	dev: 'http://localhost:5147/api',
		// 	prod: 'http://localhost:5147/api',
		// },
		externalBackofficeApiUrl: {
			dev: 'https://www.canaldorepasse.com.br/backoffice',
			prod: 'https://www.canaldorepasse.com.br/backoffice',
		},
		imagesBaseUrl: {
			anuncios: 'https://canaldorepasse.com.br/anuncios/fotos',
			grupoConcessionaria: 'https://canaldorepasse.com.br/cadastros/fotos/grupo_concessionaria',
			concessionaria: 'https://canaldorepasse.com.br/cadastros/fotos/concessionaria',
		},
	},
	auth: {
		tokenFormat: 'urlencoded',
	},
	links: {
		// Rotas assumidas pelo layout aprovado (README do pacote). Trocar pelas reais.
		forgotPassword: 'https://www.canaldorepasse.com.br/recuperar-senha.aspx',
		privacyPolicy: 'https://www.canaldorepasse.com.br/politica-de-privacidade.aspx',
		termsOfUse: 'https://www.canaldorepasse.com.br/termos-de-uso.aspx',
		avaliadorDigital: 'https://www.avaliadordigital.com.br/',
	},
};
